import { render, staticRenderFns } from "./DetailCategory.vue?vue&type=template&id=257173fa&scoped=true&"
import script from "./DetailCategory.vue?vue&type=script&lang=js&"
export * from "./DetailCategory.vue?vue&type=script&lang=js&"
import style0 from "./DetailCategory.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DetailCategory.vue?vue&type=style&index=1&id=257173fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257173fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
